export default  {
  oc: 'Business',
  affiliate: 'Affiliate',
  epc: 'EPC',
  corporate_guarantor: 'CG'
}